<template>
  <footer class="footer">
    <div class="container">
      <div class="content has-text-centered">
        <p>Разработано <a href="http://ivoice.tech" target="_blank">ivoice.tech</a></p>
      </div>
    </div>
  </footer>
</template>

<script>
export default {

  data () {
    return this.$store.state.pkg
  }

}
</script>

<style lang="scss">
@import '~bulma/sass/utilities/mixins';

.footer {
  margin-left: 180px;
  
  @include mobile() {
    margin-left: 0;
  }
  
  .social a {
    border-bottom: none !important;
  }

  .fa.fa-heart {
    color: red;
  }
}
</style>



// WEBPACK FOOTER //
// FooterBar.vue?0d2b0c9b